<template>
    <div class="order-handle-dialog-operate">
        <pt-form-item label="生产条码号:" label-width="100px" lineHeight="50" :required="true">
             <el-input placeholder="请输入生产条码号" name="labCode" v-validate="'required'" data-vv-as="生产条码号" v-model="form.labCode"></el-input>
        </pt-form-item>
    </div>
</template>

<script>
import { validate } from 'utils/validate'
export default {
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      form: JSON.stringify(this.value) === '{}' ? {
        labCode: ''
      } : this.value
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    formValidate () {
      return validate(this, this.form)
    }
  }
}
</script>

<style lang="less">
.order-handle-dialog-operate{
    .tip{
        color:#8f8f8f;
    }
    .el-input-group{
        width:200px;
    }

    .form-item{
        padding: 50px 0;
    }
}

</style>
